<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import MobileSearchPageTabs from '~/components/snippets/MobileSearchPageTabs.vue'
    import {EventBus, PACKAGE_FLIGHT_SELECTED, PACKAGE_HOTEL_SELECTED} from '~/utils/event-bus'

    @Component({mixins: [MobileSearchPageTabs]})
    export class PackageMobileSearchPageTabs extends Vue {
        get tabs() {
            const tabs = this.defaultTabs
            return [...tabs, {icon: 'mdi-bag-carry-on', label: 'tours.package'}]
        }

        mounted() {
            EventBus.$on(PACKAGE_FLIGHT_SELECTED, () => {
                this.mobileTabs = 3
            })
            EventBus.$on(PACKAGE_HOTEL_SELECTED, () => {
                this.mobileTabs = 3
            })
            if (this.$breakpoint.smAndDown) {
                this.mobileTabs = 3
            }
        }

        beforeUnmount() {
            EventBus.$off(PACKAGE_FLIGHT_SELECTED)
            EventBus.$off(PACKAGE_HOTEL_SELECTED)
        }
    }

    export default {...toNative(PackageMobileSearchPageTabs), ssrRender: MobileSearchPageTabs.ssrRender}
</script>
